import React,{useState,useEffect, useLayoutEffect} from 'react';
import {createBrowserRouter, useNavigate} from 'react-router-dom';
import {URL} from '../Helper/helper';
import DatePicker from "react-datepicker";
import {startOfMonth,addMonths,subMonths,endOfMonth} from 'date-fns'
import "react-datepicker/dist/react-datepicker.css";
import './BookingsComponent.css'
import tableData from './tableData';
import PermBookingComponent from '../Bookings/PermBookingComponent';
import RegisterComponent from '../Register/RegisterComponent';
import { invokeBookings, invokeReservations,invokeCancelDates,invokeHolidays } from '../ServiceCalls/ApiCalls';
import { requestFormReset } from 'react-dom';

function CustomTableComponent() {

  const navigate = useNavigate();
  const user_info = JSON.parse(localStorage.getItem('user'))
  const bookings_info = JSON.parse(localStorage.getItem('userBookings')) || []
  const p_bookings_info = JSON.parse(localStorage.getItem('perReservations')) || []
  const[startDate,setStartDate] = useState(new Date())
  const[day,setDay] = useState(new Date().getDay())
  const[price,setPrice] = useState(0.00)
  const[totalPrice,setTotalPrice] = useState(0.00)
  const[revenue,setRevenue] = useState(0.00)
  const[dateSelected,setDateSelected] = useState(new Date().toLocaleDateString("fr-CA"))
  const[startTime,setStartTime] = useState('')
  const[showPBooking,setShowPBooking] = useState(false)
  const[showBooking,setShowBooking] = useState(false)
  const[pageRefresh,setPageRefresh] = useState(false)
  const[timingsArr,setTimingsArr] = useState([])
  const[newRowData,setNewRowData] = useState([])
  const[courtSelected,setCourtSelected] = useState(0)
  const[bookings,setBookings] = useState([])
  const[addBookings,setAddBookings] = useState([])
  const[isLoading,setIsLoading] = useState(true)

  const[bookingObjDTO,setBookingObjDTO] = useState({
    booking_date:dateSelected,
    // booking_date_end:dateSelected,
    booking_time_start:'',
    booking_time_end:'',
    booking_item:courtSelected,
    userName:'', //user_info.userName,
    booking_status:'',
    booking_price:price,
    total_price:totalPrice,
    firstName:'',
    lastName:'',
    email:'',
    contact:'',
    playersCount:0,
    createdBy:''
  })
  const[perReservations,setPerReservations] = useState([])
  const[holidays,setHolidays] = useState([])
  const[cancelDates,setCancelDates] = useState([])
  const[mainData,setMainData] = useState([...tableData])
  const[tabData,setTabData] = useState([...tableData])

  var user_name = "";
  var pay_status = "";
  const weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const add_bookings = []
  const today = new Date()
  const next_month = addMonths(today,1)

  const min_date = startOfMonth(subMonths(today, 1));
  const max_date = endOfMonth(addMonths(today, 1));
  const min_date_users = startOfMonth(today)
  const max_date_users = endOfMonth(next_month)

  useEffect(() =>{

    async function fetchData(){
        setIsLoading(true);
        try {
            const bookingResponse = await invokeBookings();
            setBookings(bookingResponse)

            const perResData = await invokeReservations();
            setPerReservations(perResData)

            const holidayDates = await invokeHolidays();
            setHolidays(holidayDates)

            callCancelDates()

            setTimingsArr([])
            //invokeUserBookings()
            clearBookingArr()
            //callReservations()
            checkHolidays()

            // Calculate initial revenue for the selected date
            const initialRevenue = bookingResponse.reduce((acc, booking) => {
                if (booking.booking_date === dateSelected) {
                    return acc + parseFloat(booking.booking_price || 0);
                }
                return acc;
            }, 0.00);
            setRevenue(initialRevenue);
            console.log('UseEffect - []')
        } catch (error) {
            console.error('Error fetching initial data:', error);
        } finally {
            setIsLoading(false);
        }
    }

    fetchData()

  },[])

  useEffect(() =>{
    // setTotalPrice(0.00)
    callReservations()
    callCancelDates()
    invokeUserBookings()
    checkHolidays()
    // console.log('Main Data',tabData)
  },[startDate,dateSelected,showPBooking,pageRefresh])

  // Separate useEffect to recalculate revenue when bookings or date changes
  useEffect(() => {
    if (bookings && bookings.length > 0) {
      const dayRevenue = bookings.reduce((acc, booking) => {
          if (booking.booking_date === dateSelected) {
              return acc + parseFloat(booking.booking_price || 0);
          }
          return acc;
      }, 0.00);
      setRevenue(dayRevenue);
    }
  }, [bookings, dateSelected]);

  const calcRevenue = () =>{
    const tot_rev = bookings.reduce((acc, b) => {
        if (b.booking_date === dateSelected) {
            return acc + parseFloat(b.booking_price || 0);
        }
        return acc;
    }, 0.00);
    setRevenue(tot_rev); // Set the actual total, don't add to previous
  }
  const invokeUserBookings = async() =>{
    // const bookingsData = await fetch(`${URL}`+'/bookings')
    // const bookingResponse = await bookingsData.json()
    // console.log('Bookings Response',bookingResponse)
    const bookingResponse = await invokeBookings();
    setBookings(bookingResponse)
    // Revenue will be calculated automatically by useEffect when bookings state updates
  }
  const callReservations = async() =>{
    const perResData = await invokeReservations();
    setPerReservations(perResData)
  }
  const callCancelDates = async() =>{
    const cancel_dates_data = await invokeCancelDates();
    setCancelDates([...cancel_dates_data])
  }
  const formatDate = (date) =>{
      var year = date?.toLocaleString("default", { year: "numeric" });
      var month = date?.toLocaleString("default", { month: "2-digit" });
      var day = date?.toLocaleString("default", { day: "2-digit" });
      // Generate yyyy-mm-dd date string
      var formattedDate = year + "-" + month + "-" + day;
      return formattedDate;
  }

  const handlePriceTag = (t,day,rid,idx) =>{
       let timeSlot = t.timing;
       let startTimeSlot = timeSlot.split('-')[0].split(':')[0];
       let startTime = timeSlot.split('-')[0];
       let startTime2 = timeSlot.split('-')[1];
       let startMins = timeSlot.split('-')[0].split(':')[1];
       let slot_status = bookings !== null && bookings.length > 0 ? bookings.filter(b => b.booking_date === dateSelected && b.booking_time_start === startTime && parseInt(b.booking_item) === rid+1) : [];
      //let btn_status  = false;
       //let btn_color_status = '';

       if(day !== 0 && day !== 6){
            if (parseInt(startTimeSlot) >= 17 && parseInt(startTimeSlot) <= 18) {
                if(Object.keys(slot_status).length > 0){
                    //console.log('Slot - Data',bookings)
                    let len = Object.keys(slot_status).length;
                    return displayReservations(len,slot_status,rid,day,idx);
                }
                let btn_status  = checkPerReservation(perReservations,day,startTime,startTime2,rid)
                let btn_color_status =  btn_status ? 'select-court per-booking' : 'select-court select-court-1';
                return btn_color_status;

            }
            else if (parseInt(startTimeSlot) > 18) {
                if(Object.keys(slot_status).length > 0){
                    //console.log('Slot - Data',bookings)
                    let len = Object.keys(slot_status).length;
                    return displayReservations(len,slot_status,rid,day,idx);
                }

                let btn_status  = checkPerReservation(perReservations,day,startTime,startTime2,rid)
                let btn_color_status =  btn_status ? 'select-court per-booking' : 'select-court select-court-2';
                return btn_color_status;
            }
        }
        else if(day === 6){
            if(Object.keys(slot_status).length > 0){
                //console.log('Slot - Data',bookings)
                let len = Object.keys(slot_status).length;
                return displayReservations(len,slot_status,rid,day,idx);
            }
            let btn_status  = checkPerReservation(perReservations,day,startTime,startTime2,rid)
            let btn_color_status =  btn_status ? 'select-court per-booking' : 'select-court select-court-3';
            return btn_color_status;
            // checkPerReservation(perReservations,day,startTime,startTime2,rid)
            // return 'select-court select-court-3'
        }
        else if(day === 0){
            if(Object.keys(slot_status).length > 0){
                let len = Object.keys(slot_status).length;
                return displayReservations(len,slot_status,rid,day,idx);
            }
            let btn_status  = checkPerReservation(perReservations,day,startTime,startTime2,rid)
            let btn_color_status =  btn_status ? 'select-court per-booking' : 'select-court select-court-4';
            return btn_color_status;
            // checkPerReservation(perReservations,day,startTime,startTime2,rid)
            // return 'select-court select-court-4'
        }
  }
  const checkPerReservation = (perReservations,day,startTime,startTime2,rid) =>{


        const per_res_filtered = perReservations.filter(r => r.day_of_week === weekday[day])
        for(let i = 0;i < perReservations.length; i++){

            const{day_of_week,booking_date_start,booking_date_end,court_no,_id,userName} = perReservations[i];
             let start_date = new Date(booking_date_start)
             let end_date = new Date(booking_date_end)
             let date_selected = new Date(dateSelected)
             //console.log('type of date selected ',typeof dateSelected)
            if(day_of_week === weekday[day]){
                if(court_no === rid+1){
                    if(date_selected >= start_date && date_selected <= end_date){

                        // check whether the selected date matches with the cancelled dates
                         //const new_cancel_dates = cancelDates.filter(d => new Date(d.start_date) < date_selected && new Date(d.end_date) > date_selected)
                         const new_cancel_dates = cancelDates.filter(d => d.booking_id === _id)
                         if(new_cancel_dates.length > 0) {
                            for(let k=0; k < new_cancel_dates.length;k++){
                                const{start_date,end_date} = new_cancel_dates[k];
                                if(date_selected >= new Date(start_date) && date_selected <= new Date(end_date)){
                                    if(startTime === perReservations[i].booking_time_start ||
                                        startTime2 === perReservations[i].booking_time_end ){
                                            return false;
                                    }
                                }
                            }
                         }

                        if(startTime === perReservations[i].booking_time_start ||
                            startTime2 === perReservations[i].booking_time_end ){
                                displayUser(userName,null,booking_date_start,court_no,rid)
                                return true;
                                //'select-court per-booking'
                        }
                    }

                }

            }
        }
        return false;
  }
  const displayReservations = (len,slot_status,rid,day,idx) =>{
    for(let i = 0; i < len; i++){
        const{booking_date,booking_item,booking_time_start,booking_time_end,booking_status,booking_price,userName} = slot_status[i];

        if(booking_date === dateSelected && (parseInt(booking_item) - 1) === rid ){
            displayUser(userName,booking_status,booking_date,booking_item,rid)
            return 'select-court court-reserved';
        }
    }
    if(day !== 0 && day !== 6){
        if(idx < 4){
            return 'select-court select-court-1'
        }
        if(idx >= 4){
            return 'select-court select-court-2'
        }
    }
    if(day === 6){
       return 'select-court select-court-3'
    }
    if(day === 0){
        return 'select-court select-court-4'
    }

  }
  const displayUser = (name,status,b_date,b_item,rid) =>{

    if(b_date=== dateSelected && (parseInt(b_item) -1) === rid ){

            pay_status = status !== null ? status !== 'UnPaid' ? 'A$' : '' : '';
            user_name = name + '-' + pay_status;
            return user_name;
    }
    else if(b_date <= dateSelected && (parseInt(b_item) -1) === rid ){
            // user_name = name;
             pay_status = status !== null ? status !== 'UnPaid' ? 'A$' : '' : '';
             user_name = name + '-' + pay_status;
             return user_name + '' + pay_status;
            // return user_name;
    }
    return null;
    //return name;
  }

  const handleReservation = (time,day,rowno,colno) =>{

    //let startTimeSlot = time.split('-')[0].split(':')[0];
    let rowId = rowno + 1;
    let slot_price = "";
    setCourtSelected(rowId)

    const newData = tabData.map((data,i) =>{

        if(data.id === day){

            if(rowId === 1){
                const newCourt1 = data.court1.map((c,i) =>{
                    if(c.id === colno+1){
                        setPrice(c.price)
                        slot_price = c.price
                        toggleButtonCheck(c,dateSelected,time,rowno,c.price)
                        return {...c,checked:!c.checked};
                    }
                    return c;
                })
                data.court1 = [...newCourt1]
                //return {...tabData,data};
            }
            if(rowId === 2){
                const newCourt2 = data.court2.map((c,i) =>{
                    if(c.id === colno+1){
                        setPrice(c.price)
                        slot_price = c.price
                        toggleButtonCheck(c,dateSelected,time,rowno,c.price)
                        return {...c,checked:!c.checked};
                    }
                    return c;
                })
                data.court2 = [...newCourt2]
                //return data;
            }
            if(rowId === 3){
                const newCourt3 = data.court3.map((c,i) =>{
                    if(c.id === colno+1){
                        setPrice(c.price)
                        slot_price = c.price
                        toggleButtonCheck(c,dateSelected,time,rowno,c.price)
                        return {...c,checked:!c.checked};
                    }
                    return c;
                })
                data.court3 = [...newCourt3]
                //return data;
            }
            if(rowId === 4){
                const newCourt4 = data.court4.map((c,i) =>{
                    if(c.id === colno+1){
                        setPrice(c.price)
                        slot_price = c.price
                        toggleButtonCheck(c,dateSelected,time,rowno,c.price)
                        return {...c,checked:!c.checked};
                    }
                    return c;
                })
                data.court4 = [...newCourt4]
                //return data;
            }
            if(rowId === 5){
                const newCourt5 = data.court5.map((c,i) =>{
                    if(c.id === colno+1){
                        setPrice(c.price)
                        slot_price = c.price
                        toggleButtonCheck(c,dateSelected,time,rowno,c.price)
                        return {...c,checked:!c.checked};
                    }
                    return c;
                })
                data.court5 = [...newCourt5]
                //return data;
            }
            if(rowId === 6){
                const newCourt6 = data.court6.map((c,i) =>{
                    if(c.id === colno+1){
                        setPrice(c.price)
                        slot_price = c.price
                        toggleButtonCheck(c,dateSelected,time,rowno,c.price)
                        return {...c,checked:!c.checked};
                    }
                    return c;
                })
                data.court6 = [...newCourt6]
                //return data;
            }
        }
        return data;
    })
    setTabData(newData)

  }
  const toggleButtonCheck = (c,dateSelected,time,rowno,slot_price) =>{

    const bookingObj = {
        booking_date:dateSelected,
        booking_time_start:time.split('-')[0],
        booking_time_end:time.split('-')[1],
        booking_item:rowno+1,
        userName:'',
        booking_status:'',
        booking_price:c.price,
        total_price:totalPrice,
        firstName:'',
        lastName:'',
        email:'',
        contact:'',
        playersCount:0
    }

    toggleTimings(c,time)
    if(c.checked){

        if (c.bookingDate.length > 0 && c.bookingDate.includes(dateSelected)) {
            const index = c.bookingDate.indexOf(dateSelected);
            if (index > -1) { // only splice array when item is found
                if(totalPrice > 0){
                    setTotalPrice(prevPrice => parseFloat(prevPrice) - parseFloat(c.price));
                    const filtered_bookings_arr = addBookings.filter(b => b.booking_time_start !== time.split('-')[0])
                    setAddBookings(filtered_bookings_arr)
                }
                else{
                    setTotalPrice(0)
                }

                c.bookingDate.splice(index, 1); // 2nd parameter means remove one item only

            }
        }
    }
    if(!c.checked){
        setTotalPrice(prevPrice => parseFloat(prevPrice) + parseFloat(c.price));
        setAddBookings(prevState => [...prevState,bookingObj])
        c.bookingDate.push(dateSelected)

    }
    //return c;
  }
  const toggleTimings = (time,c) =>{
    const{timing,checked} = time;
    // let stTime = timing.split("-")[0];
    // let endTime = timing.split("-")[1];

    if(!checked){
        setTimingsArr(prev =>[...prev,timing])
    }
    if(checked){
        const index = timingsArr.indexOf(timing);
        if(index > -1)
            timingsArr.splice(index,1)
        setTimingsArr(timingsArr)
    }

  }
  const togglePermBookingView = (registerstatus = false) => {

    setShowBooking(false)
    setShowPBooking(prev => !prev)
    if(registerstatus){
        setAddBookings([])
        setTotalPrice(0.00)
        setPageRefresh(prev => !prev)
    }
  }

  const toggleBookingView = () => {
    setShowPBooking(prev => !prev)
    setShowBooking(true)
    //navigate('/user ')
  }
  const clearBookingArr = () =>{

    const post_booking_tab_data = tabData.map((row,idx) =>{

        for(let i=0;i < 6; i++){
           let courtno = 'court'+`${i+1}`;

            row[courtno].forEach((e,ind) =>{
               const{bookingDate} = e;
               let ar_len = bookingDate.length;
               if(ar_len > 0)
                   bookingDate.splice(0,ar_len)
               if(e.checked)
                    e.checked = !e.checked
           })
       }
       return row;
    })
    // console.log('Filtered Tab',post_booking_tab_data)
    setTabData(post_booking_tab_data)

  }
  const handleBtnDisable = (t, day, rid, idx) =>{
    if (checkHolidays()) {
        return true;
    }
    const priceTag = handlePriceTag(t, day, rid, idx);
    if (priceTag === 'select-court court-reserved' || priceTag === 'select-court per-booking') {
        return true;
    }
    if(bookings.length > 0 && perReservations.length > 0) {
        return false; // will disable bookings btn until data loaded
    }
    return true;
  }
  const checkHolidays = () =>{

    const date_select =  new Date(dateSelected).toLocaleDateString("fr-CA");
    const holidays_list = JSON.parse(localStorage.getItem('holidays')) || [];

    let holiday_status = holidays_list.filter(h =>{
      if(h.startDate === date_select && h.endDate === date_select){
            return true
      }
      if(date_select >= h.startDate  && date_select <= h.endDate){
            return true
      }
      return false
    })

    if(holiday_status.length > 0)
        return true;

    return false;
  }


  return (
    <div className='wrapper'>
        <div className='container'>
            {
                isLoading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '500px' }}>
                        <div className="text-center">
                            <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3 text-muted">Loading booking data...</p>
                        </div>
                    </div>
                ) : !showPBooking ?
                        <>
                            <div className="row justify-content-center">
                                {/* <div className="col-md-4"></div> */}
                                <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-4 py-3">
                                        <DatePicker
                                            dateFormat="yyyy-MM-dd"
                                            className='form-control text-center rounded'
                                            selected={startDate}
                                            minDate={user_info?.userName ? min_date: min_date_users }
                                            maxDate={user_info?.userName ? max_date: max_date_users }
                                            isClearable
                                            onChange={(date) => {
                                                let day_of_week = date?.getDay()
                                                let f_date = formatDate(date)
                                                setStartDate(date)
                                                setDateSelected(f_date)
                                                setDay(day_of_week)
                                            }}
                                        />
                                </div>
                                {/* <div className="col-md-4"></div> */}
                            </div>
                            <div className="row">
                                <div className="col-lg-4 col-md-12 mb-3">
                                    <div className="booking-header-section price-section">
                                        <span>Court Pricing:</span>
                                        <div>
                                            <span className='price-tag price1'>A$9.00</span>
                                            <span className='price-tag price2'>A$11.00</span>
                                            <span className='price-tag price3'>A$11.00</span>
                                            <span className='price-tag price4'>A$11.00</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-12 mb-3">
                                    <div className="booking-header-section weekday-section">
                                        <p className='mb-2'>
                                            <i className="fa fa-calendar me-2 text-primary"></i>
                                            WeekDay: <span id='dayOfWeek' className="fw-bold text-primary">{weekday[day]}</span>
                                        </p>
                                        <p className='mb-0'>
                                            <i className="fa fa-dollar me-2 text-success"></i>
                                            Total Price: A$<span id='total-price' className="fw-bold text-success">{totalPrice.toFixed(2)}</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-12 mb-3">
                                    <div className="booking-header-section action-section">
                                        <button
                                            onClick={() =>toggleBookingView()}
                                            disabled = {checkHolidays() ? true : totalPrice === 0.00 ? true : false}
                                            className="btn btn-primary bookingBtn">
                                            <i className="fa fa-calendar-check me-2"></i>
                                            Book
                                        </button>
                                        {user_info && user_info.isAdmin && (
                                            <button
                                                className='btn btn-secondary bookingBtn'
                                                disabled={totalPrice === 0.00}
                                                onClick={() =>togglePermBookingView()}
                                            >
                                                <i className="fa fa-lock me-2"></i>
                                                P-Book
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <div className="table-responsive">
                                    <table className='table table-bordered book-tab'>
                                    <thead></thead>
                                    <tbody>
                                    {
                                        !checkHolidays() ?
                                            tabData.length > 0 && tabData.filter(data => data.id === day).map((item,index) =>{
                                                        return [...Array(6)].map((el,rid) =>{
                                                            let courtItem = 'court'+`${rid+1}`;
                                                            //console.log(courtItem)
                                                                return <tr key={rid}>
                                                                            <td><span>Court-{rid+1}</span></td>
                                                                                {
                                                                                    item[courtItem].map((t,idx) =>
                                                                                        <td key={idx}>
                                                                                            <div className="court-slot-container">
                                                                                                <div className="button-container">
                                                                                                    <button
                                                                                                        onClick={() =>handleReservation(t.timing,day,rid,idx)}
                                                                                                        className={
                                                                                                            t.bookingDate.includes(dateSelected)  ?
                                                                                                                        'select-court court-selected'
                                                                                                                        :
                                                                                                                        handlePriceTag(t,day,rid,idx)
                                                                                                        }
                                                                                                        disabled={handleBtnDisable(t,day,rid,idx)}
                                                                                                    >
                                                                                                        {t.timing}
                                                                                                    </button>
                                                                                                </div>
                                                                                                <div className="info-container">
                                                                                                    <span id='user-name'>
                                                                                                        {
                                                                                                            localStorage.getItem('user') ?
                                                                                                            handlePriceTag(t,day,rid,idx) === 'select-court court-reserved' || handlePriceTag(t,day,rid,idx) === 'select-court per-booking' ? `${user_name ? user_name.split('-')[0] : ''}` : '':''
                                                                                                        }
                                                                                                    </span>
                                                                                                    <span className="text-success">
                                                                                                        {
                                                                                                            localStorage.getItem('user') ?
                                                                                                                handlePriceTag(t,day,rid,idx) === 'select-court court-reserved' || handlePriceTag(t,day,rid,idx) === 'select-court per-booking' ?`${user_name ? user_name.split('-')[1] : ''}` : '' : ''
                                                                                                        }
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                    )
                                                                                }
                                                                        </tr>
                                                        })
                                            }

                                        )
                                        :
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td colSpan={11}>
                                                    <h3 className='text-center'><i>Bookings are Closed For This Day</i>.</h3>
                                                </td>
                                            </tr>

                                        </table>

                                    }
                                    </tbody>
                                    </table>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="booking-legend-section">
                                        <div className="row align-items-center">
                                            <div className="col-md-6">
                                                <div className="legend-item">
                                                    <span id="tempReserved"></span>
                                                    <span>Temporary Reservation</span>
                                                </div>
                                                <div className="legend-item">
                                                    <span id="perReserved"></span>
                                                    <span>Permanent Reservation</span>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                {user_info && user_info.isAdmin && (
                                                    <div className="revenue-section">
                                                        <span className='revenue-label'>
                                                            <i className="fa fa-chart-line me-2"></i>
                                                            Day's Revenue:
                                                        </span>
                                                        <span className='revenue-amount'>A${revenue.toFixed(2)}</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        !showBooking  ?
                                <PermBookingComponent
                                    togglePermBookingView={togglePermBookingView}
                                    addBookings = {addBookings}
                                    formatDate = {formatDate}
                                    totalPrice={totalPrice}
                                    weekday={weekday}
                                    timingsArr={timingsArr}
                                    courtSelected = {courtSelected}
                                    date_Selected = {dateSelected}
                                />
                                :
                                <RegisterComponent
                                    addBookings = {addBookings}
                                    togglePermBookingView={togglePermBookingView}
                                    totalPrice = {totalPrice}
                                    courtSelected={courtSelected}
                                    clearBookingArr={clearBookingArr}
                                />
            }
        </div>

    </div>
  )
}
export default CustomTableComponent